import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { Response } from '../classes/response';
import { RequestService } from './request.service';
import { CommonResponse } from '../models/responses/common-response';

@Injectable({
	providedIn: 'root'
})
export class VictimDailyIncomeCalculateService {

	private path: string = '/victim-daily-income-record';

	constructor(
		private requestService: RequestService,
	) { }

	save(data: any): Observable<Response<any>> {
		return this.requestService.postJSON<any>(`${this.path}/save`, {
			data: data,
			option: {
				is_loading: true,
				is_snack_bar: true,
			},
		});
	}

	query(body: {
		search?: string,
		bra_id?: string,
		status?: string,
		page: number,
		count: number,
	}): Observable<CommonResponse<any>> {
		return this.requestService.postJSON<any>(`${this.path}`, {
			data: body,
			option: {
				is_loading: true,
			},
		});
	}

	getById(req_id?: string): Observable<CommonResponse<any>> {
		return this.requestService.getJSON<any>(`${this.path}/${req_id}`, {
			data: {},
			option: {
				is_loading: true,
			},
		});
	}

	status(id: string): Observable<CommonResponse<any>> {
		return this.requestService.patchJSON(`${this.path}/disable/${id}`, {
			data: {},
			option: {
				is_loading: true,
			},
		});
	}

	getHistory(id: string): Observable<CommonResponse<any>> {
		return this.requestService.getJSON(`${this.path}/${id}/history`, {
			data: {},
			option: {
				is_loading: true,
			},
		});
	}

	validate(data: any): Observable<Response<any>> {
		return this.requestService.postJSON<any>(`${this.path}/validate`, {
			data: data,
			option: {
				is_loading: true,
			},
		});
	}
	autoCalculate(data: any): Observable<Response<any>> {
		return this.requestService.postJSON<any>(`${this.path}/save`, {
			data: data,
			option: {
				is_loading: true,
				is_snack_bar: true,
			},
		});
	}
	getVictimContactInfo(data: any): Observable<Response<any>> {
		return this.requestService.postJSON<any>(`/victim-contact-info`, {
			data: data,
			option: {
				is_loading: true,
			},
		});
	}

	getVictimContactInfoById(id: string): Observable<Response<any>> {
		return this.requestService.getJSON<any>(`/victim-contact-info/${id}`, {
			data: {},
			option: {
				is_loading: true,
			},
		});
	}
	getVictimContactInfoHistory(id: string): Observable<Response<any>> {
		return this.requestService.getJSON<any>(`/victim-contact-info/${id}/history`, {
			data: {},
			option: {
				is_loading: true,
			},
		});
	}
	updateVictimContactInfo(id: string, data: any): Observable<Response<any>> {
		return this.requestService.putJSON<any>(`/victim-contact-info/${id}/update-contact`, {
			data: data,
			option: {
				is_loading: true,
			},
		});
	}

	getIncompleteContact(): Observable<CommonResponse<any>> {
		return this.requestService.getJSON(`/victim-contact-info/count-incomplete`, {
			data: {},
			option: {
				is_loading: false,
			},
		});
	}
}

